var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnersEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "144px",
    height: "96px",
    viewBox: "0 0 144 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "partners-empty-state") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L141,0 C142.656854,-3.04359188e-16 144,1.34314575 144,3 L144,14 L144,14 L0,14 L0,3 C-2.02906125e-16,1.34314575 1.34314575,3.04359188e-16 3,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.3%",
    y: "-3.6%",
    width: "100.7%",
    height: "107.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.847058824   0 0 0 0 0.847058824   0 0 0 0 0.847058824  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 4,
    y: 17,
    width: 46,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 46,
    height: 10,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110,13 L144,13 L144,93 C144,94.6568542 142.656854,96 141,96 L110,96 L110,96 L110,13 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 34,
    height: 83,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty-State",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blank-State",
    transform: "translate(-284.000000, -156.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "partners-empty-state",
    transform: "translate(284.000000, 156.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D8D8D8",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 143,
    height: 95,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons/Actions/Search",
    transform: "translate(45.000000, 47.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#5A5A5A",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    x: 0,
    y: 30,
    width: 110,
    height: 1
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    stroke: "#49C5B1",
    mask: "url(#mask-4)",
    strokeWidth: 2,
    fillOpacity: 0.26,
    fill: "#49C5B1",
    strokeDasharray: "4,2",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-2",
    stroke: "#49C5B1",
    mask: "url(#mask-6)",
    strokeWidth: 2,
    fillOpacity: 0.26,
    fill: "#49C5B1",
    strokeDasharray: "4,2",
    xlinkHref: "#path-5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersEmptyState);
export default __webpack_public_path__ + "static/media/partners-empty-state.5d7724cc84c9f4e4e296186cb02a9e05.svg";
export { ForwardRef as ReactComponent };